import StatsCard from '../components/StatsCard';

// Placeholder data - will be replaced with real API calls
const mockStats = [
  { title: 'Usuarios Totales', value: '156', icon: '👥', trend: { value: 12, isPositive: true } },
  { title: 'Pedidos Activos', value: '23', icon: '📦', trend: { value: 5, isPositive: true } },
  { title: 'Ingresos (MES)', value: '$4,500', icon: '💰', trend: { value: 8, isPositive: true } },
  { title: 'Tasa de Entrega', value: '94%', icon: '✅', trend: { value: 2, isPositive: true } },
];

const mockRecentOrders = [
  { id: '1', user: 'Juan Pérez', product: 'iPhone 15 Case', status: 'processing', amount: 25.99 },
  { id: '2', user: 'María García', product: 'AirPods Pro', status: 'purchased', amount: 249.00 },
  { id: '3', user: 'Carlos López', product: 'Samsung Charger', status: 'shipped_intl', amount: 35.50 },
  { id: '4', user: 'Ana Martínez', product: 'Kindle Paperwhite', status: 'completed', amount: 139.99 },
];

const statusColors: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-800',
  pending_payment: 'bg-yellow-100 text-yellow-800',
  processing: 'bg-blue-100 text-blue-800',
  purchased: 'bg-indigo-100 text-indigo-800',
  shipped_intl: 'bg-purple-100 text-purple-800',
  received_intl: 'bg-pink-100 text-pink-800',
  shipped_national: 'bg-orange-100 text-orange-800',
  received_national: 'bg-amber-100 text-amber-800',
  delivering: 'bg-teal-100 text-teal-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

export default function Dashboard() {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-800">Dashboard</h1>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {mockStats.map((stat, idx) => (
          <StatsCard key={idx} {...stat} />
        ))}
      </div>

      {/* Recent Orders */}
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 border-b">
          <h2 className="text-lg font-semibold">Pedidos Recientes</h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Usuario</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Producto</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Estado</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-500">Monto</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {mockRecentOrders.map((order) => (
                <tr key={order.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm">{order.user}</td>
                  <td className="px-4 py-3 text-sm">{order.product}</td>
                  <td className="px-4 py-3">
                    <span className={`px-2 py-1 rounded-full text-xs ${statusColors[order.status] || 'bg-gray-100'}`}>
                      {order.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-sm text-right">${order.amount.toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}